import React from "react";
import AppContent from "templates/appContent";
import BackgroundJobsNavigator from "containers/backgroundJobsNavigator";

export default props => (
  <AppContent
    title="Processi in esecuzione"
    secondaryNavigator={<BackgroundJobsNavigator />}
    {...props}
  />
);
